import {
  Entity,
  PrimaryGeneratedColumn,
  Column,
  CreateDateColumn,
  UpdateDateColumn,
  VersionColumn,
} from "typeorm";

@Entity("roles")
export class RoleEntity {
  @PrimaryGeneratedColumn({
    name: "id",
  })
  id: number;

  @Column("varchar", {
    name: "role",
  })
  role: string;

  @Column("varchar", {
    name: "unit",
  })
  unit: string;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active",
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime",
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user",
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: "datetime",
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag",
  })
  versionFlag: number;

  // @Column("enum", {
  //   name: "Role_Status",
  //   enum: ,
  // })
  // vehicleStatus: ;
}
